export type ErrorMessage = {
  title: string;
  description: string;
};

export type TErrorMessages = Partial<{
  [K in keyof typeof defaultErrorMessages]: ErrorMessage;
}>;

export const defaultErrorMessages = {
  notFound: {
    title: 'Not Found',
    description: 'The requested resource could not be found',
  },
  unauthorized: {
    title: 'Unauthorized',
    description: 'You are not authorized to access this resource',
  },
  fetchError: {
    title: 'Fetch Error',
    description: 'An error occurred while fetching the resource',
  },
  forbiddenError: {
    title: 'Forbidden',
    description: 'You are not allowed to access this resource',
  },
  internalServerError: {
    title: 'Internal Server Error',
    description: 'An error occurred on the server',
  },
  badRequest: {
    title: 'Bad Request',
    description: 'The request was invalid',
  },
  abortError: {
    title: 'Abort Error',
    description: 'Request manually aborted',
  },
  baseError: {
    title: 'Error',
    description: 'An unexpected error occurred',
  },
  methodNotAllowed: {
    title: 'Method Not Allowed',
    description: 'The request method is not allowed',
  },
  unhandledError: {
    title: 'Unhandled Error',
    description: 'An unhandled error occurred',
  },
};
